import * as React from "react";
import {useTranslation} from "react-i18next";
import {useCheckoutContext} from "../../CheckoutContextProvider/CheckoutContextProvider";
import styles from "./Summary.module.scss";
import {useCartContext} from "../../../cart/CartContextProvider/CartContextProvider";
import {FUNDING} from "@paypal/react-paypal-js";

interface ISummaryPaymentOptionProps {
  goToPaymentView?: () => void;
}

const SummaryPaymentOption: React.FC<ISummaryPaymentOptionProps> = (props) => {
  const {checkout} = useCheckoutContext();
  const {viewState} = useCartContext();

  const {t} = useTranslation(["errorcodes", "translations"]);
  const {goToPaymentView} = props;

  let name = t("checkout.noValidPaymentType");
  let description = t("checkout.goToPaymentStep");

  const {paymentInformation} = checkout.cartData;
  if (paymentInformation) {
    name = paymentInformation.paymentName || checkout.paymentId?.toString() || "";
    description = paymentInformation.paymentDescription;
    if (viewState.paypalInfos?.paymentSource === FUNDING.PAYLATER) {
      name = t("checkout.paylaterName");
      description = t("checkout.paylaterDescription");
    }
  }

  return (
    <section>
      <h2>{t("checkout.paymentOptions")}</h2>

      {goToPaymentView && (
        <button type="button" className={styles.pen} onClick={goToPaymentView}>
          <span className="icon icon-pencil--blue icon-size--20">&#160;</span>
          <span className="visually-hidden">{t("checkout.editPayment")}</span>
        </button>
      )}

      <div className="SimpleRadioList ArrowBorder">
        <div className="SimpleRadioList__SingleLine">
          <p dangerouslySetInnerHTML={{__html: name}} />
          <p dangerouslySetInnerHTML={{__html: description}} />
        </div>
      </div>
    </section>
  );
};

export default SummaryPaymentOption;
